import React from "react";

import { CAROUSEL_RESPONSIVE_IMAGE } from "utils/Utilities";

/**
 * get the first component by its type
 */
export const getComponentByType = (components, type) =>
  components?.find((item) => item?.type === type);

export const getComponentByTypeOrName = ({ components, type, name }) => {
  if (name) {
    return components?.find(
      (item) =>
        item?.type === type &&
        item?.static_component?.smartlist_module_name === name,
    );
  }
  return components?.find((item) => item?.type === type);
};

/**
 * get the right translation
 */
export const getTranslation = (lang, index, data) => {
  let defaultIndex = 0;

  if (index && index.default && index.default.true)
    defaultIndex = index.default.true[0];

  if (index && index.language && index.language[lang])
    defaultIndex = index.language[lang][0];

  let translation = {};
  if (data && data.length > defaultIndex) translation = data[defaultIndex];

  return translation;
};

export const getAvailablePlatforms = (plan_options) => {
  const platforms = ["web"];

  plan_options?.forEach((option) => {
    switch (option.type) {
      case "ios_app":
        platforms.push("ios");
        break;
      case "android_app":
        platforms.push("android");
        break;
      case "tvOS_app":
        platforms.push("tvos");
        break;
      case "android_tv_app":
        platforms.push("androidtv");
        break;
      case "firetv_app":
        platforms.push("firetv");
        break;
      case "roku_app":
        platforms.push("roku");
        break;
      case "tizen_app":
        platforms.push("tizen");
        break;
    }
  });

  return platforms;
};

export const defaultStyles = {
  default: {
    global: {
      backgroundColor: "#FFFFFF",
    },
    text: {
      color: "#3C3C40",
      fontFamily: "Roboto",
    },
    text_hover: {
      color: "#828282",
      fontFamily: "Roboto",
    },
    title: {
      color: "#3C3C40",
      fontFamily: "Archivo Black",
    },
    title_hover: {
      color: "#000000",
      fontFamily: "Archivo Black",
    },
    input: {
      color: "#A2A2A2",
      backgroundColor: "#FFFFFF",
      borderColor: "#A2A2A2",
    },
    input_focus: {
      color: "#1e1e20",
      backgroundColor: "#ffffff",
      borderColor: "#1e1e20",
    },
    icon: {
      color: "#a2a2a2",
      borderColor: "#a2a2a2",
    },
    icon_hover: {
      color: "#3c3c40",
      borderColor: "#3c3c40",
    },
    button: {
      color: "#1e1e20",
      backgroundColor: "#ddd",
      borderColor: "#1e1e20",
      fontFamily: "Roboto",
    },
    button_hover: {
      color: "#fff",
      backgroundColor: "#1e1e20",
      borderColor: "#1e1e20",
      fontFamily: "Roboto",
    },
    checkbox: {
      color: "#3C3C40",
    },
    checkbox_marker_checked: {
      backgroundColor: "#2d6095",
    },
  },
  dialog: {
    global: {
      backgroundColor: "#1e1e20",
      color: "#cacaca",
      fontFamily: "Roboto",
    },
    text: {
      color: "#cacaca",
      fontFamily: "Roboto",
    },
    title: {
      color: "#cacaca",
      fontFamily: "Roboto",
    },
    obutton_primary: {
      color: "#1e1e20",
      backgroundColor: "#cacaca",
      borderRadius: "44px",
      border: "2px solid #cacaca",
    },
    obutton_primary_hover: {
      color: "#cacaca",
      borderRadius: "44px",
      border: "2px solid #cacaca",
    },
    obutton_secondary: {
      color: "#cacaca",
    },
    obutton_secondary_hover: {
      color: "#ffffff",
    },
  },
  footer: {
    global: {
      backgroundColor: "#1e1e20",
    },
    text: {
      color: "#a2a2a2",
      fontFamily: "Roboto",
    },
    text_hover: {
      color: "#ffffff",
      fontFamily: "Roboto",
    },
    button: {
      color: "#a2a2a2",
      backgroundColor: "transparent",
      borderColor: "#a2a2a2",
      fontFamily: "Archivo",
    },
    button_hover: {
      color: "#ffffff",
      backgroundColor: "transparent",
      borderColor: "#ffffff",
      fontFamily: "Archivo",
    },
  },
  header: {
    global: {
      backgroundColor: "#1e1e20",
      color: "#a2a2a2",
    },
    text: {
      color: "#a2a2a2",
      fontFamily: "Roboto",
    },
    icon: {
      color: "#a2a2a2",
    },
    icon_hover: {
      color: "#a2a2a2",
    },
    text_hover: {
      color: "#ffffff",
      fontFamily: "Roboto",
    },
    button: {
      color: "#a2a2a2",
      backgroundColor: "transparent",
      borderColor: "#a2a2a2",
      fontFamily: "Archivo",
    },
    button_hover: {
      color: "#ffffff",
      backgroundColor: "transparent",
      borderColor: "#ffffff",
      fontFamily: "Archivo",
    },
  },
  home: {
    button: {
      color: "#a2a2a2",
      backgroundColor: "#ffffff",
      borderColor: "#a2a2a2",
      fontFamily: "Archivo",
    },
    button_hover: {
      color: "#1e1e20",
      backgroundColor: "#ffffff",
      borderColor: "#1e1e20",
      fontFamily: "Archivo",
    },
    icon: {
      color: "#a2a2a2",
      borderColor: "#a2a2a2",
    },
    icon_hover: {
      color: "#1e1e20",
      borderColor: "#1e1e20",
    },
  },
  profile: {
    text: {
      color: "#A2A2A2",
      fontFamily: "Roboto",
    },
    text_hover: {
      color: "#000000",
      fontFamily: "Roboto",
    },
    icon: {
      color: "#A2A2A2",
      borderColor: "#000000",
    },
  },
  player: {
    global: {
      backgroundColor: "#1e1e20",
    },
    slider: {
      backgroundColor: "#ffffff",
    },
  },
};
